
import React from "react";
import { useNavigate } from "react-router-dom";

const HomeButton = () => {
  const navigate = useNavigate();
  
  return (
    <div className="mt-8 text-center">
      <button 
        onClick={() => navigate('/', { replace: true })} 
        className="text-mono-platinum/80 hover:text-mono-seasalt transition-colors text-sm"
      >
        Back to home
      </button>
    </div>
  );
};

export default HomeButton;
